import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import DriverQueue from '../../../models/DriverQueue';
import { Delete, Publish } from '@material-ui/icons';
import { Tooltip, Paper, Switch, Select, MenuItem } from '@material-ui/core';
import commonStyles from '../../common/common.module.css';
import linkIcon from '../../../assets/link_blue.svg';
import moment from 'moment';

const iconFontSize = 20;
const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    materialIconDisabled: {
      color: 'lightgrey',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    functionPanel: {
      display: 'flex',
      justifyContent: 'space-around'
    },
    wrapper: {
      marginTop: '14px',
    },
    select: {
      width: '20%',
      marginTop: 0
    },
    headerDiv: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px'
    }
  });

  
interface DriverQueueListProps {
  classes: any;
  queue: Array<DriverQueue>;
  deleteDriverInQueue?: (id: number) => void;
  createNewOrder?: (data: DriverQueue) => void;
  linkOrder?: (id: number) => void;
  isUsedToModal?: boolean;
  type: string;
  view?: boolean;
  handleChangeDataView?: (value: boolean) => void;
  completeDriver?: (data: DriverQueue) => void;
  airlines: string[];
  selectedAirlines: string[];
  handleChange: (event: any) => void;
  showAirlineFilter: boolean;
};

const PADDING_RIGHT_CELLS = '12px';
const PADDING_LEFT_CELLS = '8px';
const cellStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };
const headerStyle = { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS };

const driverQueueList = (props: DriverQueueListProps) => {

  const { classes } = props;
  const airlineOptions = props.airlines.map((airline: string, index: number) => {
    return (
      <MenuItem key={ index } value={ airline } className={ classes.menuItem }>{ airline}</MenuItem>
    )
  });

  return (

    <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` }>
      <div className={ classes.headerDiv }>
      <h3 className={ `${ commonStyles.header }` }> { props.type === 'queue' ? 'Driver Queue' : 'Now Serving' } List</h3>
      { props.type !== 'queue' && <div>
        <small className={commonStyles.switchLabel}>Warehouse</small>
        <Switch
          name="checkedA"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
          color="primary"
          checked={ props.view }
          onChange={  () => props.handleChangeDataView ? props.handleChangeDataView(!props.view) : null }
        />
      </div>}
      { props.showAirlineFilter && 
        <div className={` ${ commonStyles.inputLabelWrapper } ${ commonStyles.mb3 } ${ classes.select }`}>
          <label className={ commonStyles.inputLabel }>Filter Airline </label>
          <Select
            variant="outlined"
            className={ classes.overrideBorder }
            multiple
            value={ props.selectedAirlines }
            onChange={(event: any) => props.handleChange(event)}
            renderValue={(selected: any) => {
              if (Array.isArray(selected) && selected.length === props.airlines.length) {
                return 'All Airlines';
              }
              return selected.join(', ');
            }}
          >
            { airlineOptions }
          </Select>
        </div> }
      </div>

    
      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

        data={ props.queue }

        columns={[

          { title: 'Driver Name', field: '', cellStyle, headerStyle,
            render: (rowData: DriverQueue) => {
              return <span>{rowData.info.first_name} {rowData.info.last_name}</span>
            }
          },
          { title: 'Trucking Company', field: '', cellStyle, headerStyle,
            render: (rowData: DriverQueue) => {
              return <span>{ rowData.info.company } </span>
            }
          },
          {
            title: 'Airline', field: '', cellStyle, headerStyle,
            render: (rowData: DriverQueue) => {
              const airlines = rowData.info.airlines ? rowData.info.airlines.map(airline => {
                return  <div> { airline } </div>
               }) : <div></div>;
               return airlines
            }
          },
          { title: 'Remarks', field: '', cellStyle, headerStyle,
          render: (rowData: DriverQueue) => {
            return <span>{ rowData.info.remarks } </span>
          }
          },
          {
            title: 'Wait Time', field: '', cellStyle, headerStyle,
            render: (rowData: DriverQueue) => {
              return <span> { moment(rowData.check_in).fromNow(true) }</span>
            }
          },
          {
            title: 'Type', field: '', cellStyle, headerStyle,
            render: (rowData: DriverQueue) => {
              return <span>{ rowData.info.appointment ? `Appointment at ${ rowData.info.appointmentTime } - ${ rowData.info.orderNumber }` : 'Walk In' }</span>
            }
          },
          props.isUsedToModal ? { title: 'Action', cellStyle, headerStyle: { paddingRight: PADDING_RIGHT_CELLS, paddingLeft: PADDING_LEFT_CELLS, textAlign: 'center' },
            render: (rowData: DriverQueue) => {   
              return <span className={classes.functionPanel} >
                { rowData.info.appointment && props.type == 'queue' && <Tooltip title="Link to Order">
                  <img
                    alt='logo'
                    src={ linkIcon }
                    onClick={ () => { props.linkOrder ? props.linkOrder(rowData.id): null } }
                  />
                </Tooltip> }
                { !rowData.info.appointment && !props.view && <Tooltip title={ props.type == 'queue' ? "Create Order" : 'Back to waitlist'}>
                  <Publish className={  props.createNewOrder && (rowData.info.bulb || props.type == 'queue') ? classes.materialIcon : classes.materialIconDisabled } onClick={() => { props.createNewOrder && (rowData.info.bulb || props.type == 'queue') ? props.createNewOrder(rowData) : null }} />
                </Tooltip >}
                { props.view && <Tooltip title={'Mark as completed'}>
                  <Publish className={ classes.materialIcon } onClick={() => { props.completeDriver && props.view ? props.completeDriver(rowData) : null }} />
                </Tooltip >}
                <Tooltip title="Delete">
                  <Delete className={  props.deleteDriverInQueue ? classes.materialIcon : classes.materialIconDisabled } onClick={() => { props.deleteDriverInQueue  ? props.deleteDriverInQueue(rowData.id): null }} />
                </Tooltip>
              </span>;
            }
          } : { title: ''}
        ]}
          
        options={{
          paging: false,
          pageSize: 5,
          maxBodyHeight: '342px',
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15,20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  )
}

export default withStyles(styles)(driverQueueList);